import { FormikActions, FormikValues } from 'formik';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import ConsentForm from '../components/consent-form';
import { FLYBITS } from '../constants';
import { withDefaultStyles } from '../utils/material-ui/hoc';

class Consent extends React.Component<any, any> {
    public render() {
        return (
            <div style={this.props.style}>
                <ConsentForm actionUrl={FLYBITS.IDP_HOST + '/interaction/' + this.props.match.params.grant} onConsent={this.doConsent} />
            </div>
        );
    }
    private doConsent = async (values: FormikValues, actions: FormikActions<any>) => {
        actions.setSubmitting(false);
    }

}
const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(withRouter(connect(
    mapStateToProps,
)(Consent)));



// WEBPACK FOOTER //
// ./src/containers/consent.tsx